export default {
      id: "bluetooth-indicator-usage",
      viewBox: "0 0 14 15",
      url: __webpack_public_path__ + "img/icons.svg#bluetooth-indicator",
      toString: function () {
        return this.url;
      }
    }